import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useFirebaseApp } from 'reactfire';

// Images
import Freetakistan from '../../assets/images/Freetakistan.png';

// Bootstrap
import { Form } from 'react-bootstrap';

// Components
import Header from '../../components/Header/index';

// Firebase
import { db } from '../../utils/firebaseConfig';

// Material-ui
import { TextField, Snackbar, Button } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const Cadastro = () => {
  let history = useHistory();
  const firebase = useFirebaseApp();

  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmaSenha, setConfirmaSenha] = useState('');
  const [alert, setAlert] = useState('');

  const [isLoading, setIsLoading] = useState(false);

  // Alert
  const [openAlert, setShowAlert] = useState(false);
  const [error, setError] = useState(true);

  const showAlert = () => setShowAlert(true);

  const hideAlert = () => setShowAlert(false);

  const CadastrarUsuario = () => {
    // Apenas email e senha são utilizados para criar uma conta no firebase
    const form = {
      nome: nome,
      email: email,
      senha: senha,
      confirmaSenha: confirmaSenha
    }

    if (form.email.length === 0
      || form.senha.length === 0
      || form.confirmaSenha.length === 0
      || form.nome.length === 0) {
      setIsLoading(false);
      setAlert('Preencha todos os campos para se cadastrar.')
      return showAlert();
    }

    if (form.senha !== form.confirmaSenha) {
      setIsLoading(false);
      setAlert('Confirmação de senha incorreta.')
      return showAlert();
    }

    if (form.senha.length < 8) {
      setIsLoading(false);
      setAlert('A senha precisa ter no mínimo 8 caracteres.')
      return showAlert();
    }

    // Criação de usuário com o Firebase
    firebase.auth().createUserWithEmailAndPassword(form.email, form.senha)
      .then(resp => {
        // Se cair no then, o usuário é autenticado automaticamente
        setIsLoading(false);
        if (resp.user) {
          // Criação de usuário no FireStore para adicionar permissões
          db.collection('Usuarios').doc(resp.user?.uid)
            .set({
              email: email,
              nome: nome,
              isAdmin: false,
              emailVerified: false
            })
            .catch(err => {
              console.log('Houve um erro na criação do usuário no FireStore.')
            })

          // Envia para página de verificação de email
          history.push('/email-verification');
        }
        else {
          setAlert('Houve um erro interno na criação do usuário, tente novamente mais tarde ou comunique os administradores do sistema.')
          return showAlert();
        }
      })
      .catch(err => {
        setIsLoading(false);
        if (err.code === 'auth/email-already-in-use') {
          setAlert('Este email já esta em uso no nosso site.')
          return showAlert();
        }
        else if (err.code === 'auth/invalid-email') {
          setAlert('Email inválido.')
          return showAlert();
        }
        console.log(err.code);
      })
  }

  return (
    <div>
      <Header />
      <Form className='form-signin' onSubmit={event => {
        event.preventDefault();
        CadastrarUsuario();
      }}>
        <div className='text-center'>
          <img src={Freetakistan} alt='Freetakistan Logo' style={{ width: '150px' }} />
        </div>

        <br />
        <i><p style={{ textAlign: 'center', fontWeight: 'bold' }}>Cadastro de novo usuário</p></i>
        <hr />

        <TextField
          autoFocus
          id="nome"
          margin="dense"
          label="Seu nome"
          type="text"
          fullWidth
          value={nome}
          onChange={event => setNome(event.target.value)}
        />

        <TextField
          id="email"
          margin="dense"
          label="Informe o email"
          type="email"
          fullWidth
          value={email}
          onChange={event => setEmail(event.target.value)}
        />

        <TextField
          id="senha"
          margin="dense"
          label="Senha"
          type="password"
          fullWidth
          value={senha}
          onChange={event => setSenha(event.target.value)}
        />

        <TextField
          id="confirmSenha"
          margin="dense"
          label="Confirme sua senha"
          type="password"
          fullWidth
          value={confirmaSenha}
          onChange={event => setConfirmaSenha(event.target.value)}
        />

        <Snackbar open={openAlert} autoHideDuration={6000} onClose={() => {
          hideAlert();
        }}>
          <Alert severity={error ? 'error' : 'success'} variant="outlined" onClose={() => {
            hideAlert();
          }}>
            {alert}
          </Alert>
        </Snackbar>

        <div className="btn-center">
          <Button variant="contained" id="btn-padrao" type="submit" >
            Cadastrar
          </Button>
        </div>
      </Form>

    </div>
  );
}

export default Cadastro;